var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { LazyLoader } from '../../../ts/components/LazyLoader';
export class Projects extends Component {
    constructor() {
        super('Projects', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Randomize the order
            if ($('.module-projects--project').length > 0) {
                const projects = Array.from(document.querySelectorAll('.module-projects--project'));
                const shuffledProjects = projects.sort(() => Math.random() - 0.5);
                const container = $('.module-projects__projects').empty();
                if (container) {
                    shuffledProjects.forEach(project => container.append($(project)));
                }
            }
            $('.module-projects--filters a').on('click', (event, button) => {
                event.preventDefault();
                if (button.hasClass('is-active') && button.data('id') !== 'all') {
                    button.removeClass('is-active');
                }
                else {
                    $('.module-projects--filters a').removeClass('is-active');
                    button.addClass('is-active');
                }
                this.filterProjects(parseInt($('.module-projects--filters a.is-active').data('id')) || 0);
                window.history.replaceState(null, '', button.data('id') === 'all' ? window.location.pathname : `#${button.data('slug')}`);
            });
            this.removeEmptyFilters();
            // Hash management
            const hash = window.location.hash.substring(1);
            if (hash) {
                const filterButton = $(`.module-projects--filters a[data-slug="${hash}"]`);
                if (filterButton.length > 0) {
                    filterButton.trigger('click');
                }
            }
            this.success();
        });
    }
    removeEmptyFilters() {
        const filter_ids = [];
        $('.module-projects--project').each((project) => {
            const filters = project.data('categories').split(',').map((filter) => parseInt(filter.trim()));
            filter_ids.push(...filters);
        });
        const unique_filter_ids = Array.from(new Set(filter_ids));
        $('.module-projects--filters a').each((filter) => {
            const filter_id = parseInt(filter.data('id'));
            if (!unique_filter_ids.includes(filter_id) && filter.data('id') != 'all')
                filter.remove();
        });
    }
    filterProjects(filter_id) {
        $('.module-projects--project').removeClass('d-none').each((project) => {
            const filters = project.data('categories').split(',').map((filter) => parseInt(filter.trim()));
            if (!filters.includes(filter_id) && filter_id !== 0)
                project.addClass('d-none');
        });
        LazyLoader.checkImageVisibility();
    }
}
